// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_oc-0";
export var buttonContainer = "_oc-3";
export var cancelButton = "_oc-4";
export var headerSection = "_oc-6";
export var headerTitle = "_oc-9";
export var messageSideLeft = "_oc-1";
export var messageSideRight = "_oc-2";
export var orderNumberContainer = "_oc-7";
export var orderNumberLabel = "_oc-8";
export var submitButton = "_oc-5";